export const withHiddenSponsored =
  (Component: any) =>
  ({ ...props }: any) => {
    const isSponsored = props.isSponsored;
    if (isSponsored) return null;

    return (
      <div className="print:hidden w-full">
        <Component {...props} />
      </div>
    );
  };
